import styled from "styled-components";

export const EmailConfirmationLayoutContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
    background-image: radial-gradient(circle at -10% 50%, 
      ${({ theme }) => theme.colors.secondaryBlue.main} 5%, 
      white 50%);
`;

export const EmailConfirmationLayoutContent = styled.div`
  position: relative;
  width: 50%;
  height: 100vh;
  padding: 4rem;
  display: flex;
  flex-direction: column;
`;

export const TalentLogo = styled.img`
  max-width: 20rem;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  max-width: 25rem;
  margin-top: 8rem; 
`;

export const Description = styled.span`
  font-size: 1rem;
  line-height: 150%;
  color: #424242;
  line-height: 1.5rem;
`;

export const Title = styled(Description)`
  font-size: 1.5rem;
`;

export const ContinueButton = styled.button`
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.primaryPurple.main};
  font-weight: 700;
  color: white;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryPurple.hover};
  }

  &:disabled {
    cursor: default;
    background-color: #9E9E9E;
  }
`;
